import React, { useContext } from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import FeedThumb from '../_partials/FeedThumb';

import s from './Feed.scss';

export interface Props {
  items: PapiDeviation[];
  profileOwnerUser: PapiUser;
  isOwner?: boolean;
}

const FeedWidget: React.FC<Props> = ({ items }) => {
  const isMobile = useContext(MobileContext);
  const RootComponent: any = isMobile ? SwipeSlider : 'div';

  return (
    <RootComponent className={s['root']}>
      {items.map((item: PapiDeviation, i: number) => (
        <BiLoggerContextProvider
          key={`${item.typeId}-${item.deviationId}`}
          value={{ rank: i, sectionname: 'postsfeed_widget' }}
        >
          <FeedThumb
            deviation={item}
            className={s['item']}
            withComments
            withWatch
          />
        </BiLoggerContextProvider>
      ))}
    </RootComponent>
  );
};

export default FeedWidget;
